export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '国家店铺',
    prop: 'countryMarketValue',
    components: [{
        name: 'gj-country-server-select',
        prop: 'countryMarketValue'
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: {
        countryIds: [],
        marketIds: []
    }
}, {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    slot: 'dateRange',
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}, {
    prop: 'dateRangeType',
    defaultValue: 'DAY'
}, {
    prop: 'categoryIds',
    isFormItem: true,
    labelWidth: '120px',
    label: '品类',
    components() {
        return [{
            name: 'gj-category-select',
            prop: 'categoryIds',
            propsData: {
                placeholder: '请选择品类',
                collapseTags: true,
                multiple: true,
                style: {
                    width: '150px'
                }
            }
        }]
    },
    defaultValue: []
}, {
    prop: 'operationStates',
    isFormItem: true,
    labelWidth: '120px',
    label: '运营状态',
    components() {
        return [{
            name: 'gj-operation-state-select',
            prop: 'operationStates',
            propsData: {
                placeholder: '运营状态',
                multiple: true,
                style: {
                    width: '150px'
                }
            }
        }]
    },
    defaultValue: []
}]
